module.exports = __webpack_public_path__ + "6da0845e01c94cb6a397cea0c00913ff.png";